<!-- 总交易报表 -->
<template>
  <div class="container">
    <mg-search-form :span="8" :form-item-list="formItemList" label-width="auto" @getSearchFormData="handleSearch" />

    <div class="table-content">
      <mg-vxe-table
        v-if="loaded"
        ref="mgTable"
        :columns.sync="tableColumns"
        :api="page"
        :apiParams="queryForm"
        style="height: 100%"
        businessType="RETAIL_COM_TRANSACTION_REPORT"
        :configurable="true"
        :formatData="handleFormatter"
        show-footer
        :summary-option="summaryOption"
        @column-change="columnChange"
        :wrapperHeight="`calc(100vh - ${$pxToRem(186)})`"
      >
        <template #topright>
          <mg-export-button @exporting="handleExporting"></mg-export-button>
        </template>

        <template #totalAmt>
          <span>{{ $t('收入') }}</span>
          <el-tooltip
            effect="dark"
            :content="$t('说明：收入=销售金额-退货金额，包含使用会员支付订单金额')"
            placement="top"
          >
            <i class="el-icon-info" style="color: #e60012; font-size: 18px"></i>
          </el-tooltip>
        </template>

        <template #totalActualAmt>
          <span>{{ $t('实收款金额') }}</span>
          <el-tooltip
            effect="dark"
            :content="$t('说明：店铺在交易日期范围内应该收到的客户付款金额，包含会员充值和订单现金收款金额')"
            placement="top"
          >
            <i class="el-icon-info" style="color: #e60012; font-size: 18px"></i>
          </el-tooltip>
        </template>
      </mg-vxe-table>
    </div>
  </div>
</template>
<script>
  import { page, pageExport, pageSummary } from '@/api/report/comTransaction'
  import { downloadFile } from '@/utils'
  import { getPaymentType } from '@/api/basic/payment'
  import i18n from '@/locale'
  export default {
    name: 'TransactionReport',
    data() {
      const startDate = dayjs().startOf('day').valueOf()
      const endDate = dayjs().endOf('day').valueOf()
      return {
        queryForm: {
          page: 1,
          size: 50,
          summaryType: 'creator',
          completeTimeStart: startDate,
          completeTimeEnd: endDate,
        },
        formItemList: [
          {
            type: 'FormItemSelect',
            label: i18n.t('业绩汇总方式'),
            model: 'summaryType',
            initialValue: 'creator',
            span: 12,
            rules: [{ required: true, message: i18n.t('请选择业绩汇总方式') }],
            options: [
              { label: i18n.t('按创建人(收银员)统计'), value: 'creator' },
              { label: i18n.t('按业务员统计'), value: 'saleMan' },
              { label: i18n.t('汇总统计'), value: 'summary' },
            ],
          },

          {
            type: 'FormItemDate',
            label: i18n.t('交易日期'),
            model: 'completeTime',
            span: 12,
            rules: [{ required: true, message: i18n.t('请选择交易日期') }],
            initialValue: [startDate, endDate],
            attrs: {
              type: 'daterange',
              format: 'yyyy-MM-dd',
              valueFormat: 'timestamp',
              begin: 'completeTimeStart',
              end: 'completeTimeEnd',
            },
          },
        ],

        exportColumns: [],

        tableColumns: [],

        summaryOption: {},

        loaded: false,
      }
    },

    async mounted() {
      // const { data } = await this.$store.dispatch('payment/FETCH_PAYMENT_TYPE_LIST')
      const { data } = await getPaymentType({'sortBy':"sort:ASC;paymentTypeId:ASC"})
      //  console.log('TIPS list:',data)
      this.tableColumns = [
        ...[
          { type: 'seq', label: i18n.t('序号'), width: 66, fixed: 'left' },
          { label: i18n.t('员工'), prop: 'name', width: 80, fixed: 'left' },
          { headerSlot: 'totalAmt', prop: 'totalAmt', width: 80 },
          { headerSlot: 'totalActualAmt', prop: 'totalActualAmt', width: 150 },
          { label: i18n.t('会员充值金额'), prop: 'memberPaymentAmt', width: 120 },
          { label: i18n.t('会员赠送金额'), prop: 'memberBonusAmt', width: 120 },
          { label: i18n.t('销售笔数'), prop: 'receivableNum', width: 110 },
          { label: i18n.t('销售金额'), prop: 'receivableAmt', width: 110 },
          { label: i18n.t('客单价'), prop: 'perReceivableAmt', width: 100 },
          { label: i18n.t('退货笔数'), prop: 'returnNum', width: 110 },
          { label: i18n.t('退货金额'), prop: 'returnAmt', width: 110 },
          // { label: i18n.t('会员支付'), prop: '1001', width: 100 },
          // { label: i18n.t('扫码支付'), prop: '1002', width: 100 },
        ],

        ...data.map((item) => ({ label: item.paymentTypeName, prop: item.paymentTypeCode, minWidth: 100 })),
      ]

      this.loaded = true

      this.handleSearch()
    },

    methods: {
      page,
      /**
       * 查询
       * @param params
       */
      async handleSearch(params) {
        this.queryForm = { ...this.queryForm, ...params }
        await this.$nextTick()
        this.$refs.mgTable.handleCurrentChange(1)
      },

      /**
       * 数据格式化
       * 全量合计
       * @param items
       */
      async handleFormatter(items) {
        for (const item of items) {
          // 根据支付类型匹配对应的支付金额
          const customField = JSON.parse(item.customField)
          Object.entries(customField).forEach(([key, value]) => {
            item[key] = value
          })
        }

        // 合计接口
        const { data } = await pageSummary(this.queryForm)

        this.summaryOption = JSON.parse(data)
      },

      columnChange(columns) {
        this.exportColumns = columns
      },

      /**
       * 导出
       * @param done
       */
      handleExporting(done) {
        if (this.exportColumns.length === 0) this.exportColumns = this.tableColumns
        pageExport({
          ...this.queryForm,
          includeFieldNames: this.exportColumns.filter((item) => item.prop && !item.hidden).map((item) => item.prop),
        })
          .then((data) => {
            downloadFile(data)
          })
          .finally(() => {
            done()
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .table-content {
      flex: 1;
      height: 0;
    }
  }
</style>
